export const personalDetailsData = [
  { label: 'Email', value: 'email' },
  { label: 'Date of Birth', value: 'dob' },
  { label: 'Phone', value: 'mobileNo' },
  { label: 'Gender', value: 'sex' },
  { label: 'Blood Group', value: 'bloodGroup' },
  { label: 'Marital Status', value: 'maritalStatus' },
  { label: 'Adhaar No', value: 'aadhaarCardNo' },
];

export const addressDetailsData = [
  { label: 'Parent Name', value: 'parentName' },
  { label: 'House Name', value: 'houseName' },
  { label: 'Street / Area', value: 'streetOrArea' },
  { label: 'City', value: 'city' },
  { label: 'District', value: 'district' },
  { label: 'State', value: 'state' },
  { label: 'Country', value: 'country' },
  { label: 'Pincode', value: 'pinCode' },
];
/* export const academicDetailsData = [
  { label: 'Course', value: '' },
  { label: 'Stream', value: '' },
  { label: 'Course Status', value: '' },
  { label: 'Year of Passing', value: '' },
]; */
export const professionalDetailsData = [
  { label: 'Role', value: 'designationName' },
  { label: 'Department', value: 'deptName' },
  { label: 'Wing Name', value: 'wingName' },
  { label: 'User ID', value: 'userId' },
  { label: 'PF No', value: 'pfNo' },
  { label: 'ESI No', value: 'esicNo' },
  { label: 'Pan Card', value: 'panCardNo' },
];

export const BankDetailsData = [
  { label: 'Account Holder', value: 'accountHolder' },
  { label: 'Bank Name', value: 'bankName' },
  { label: 'Account Number', value: 'accountNo' },
  { label: 'IFSC Code', value: 'ifscCode' },
  { label: 'Branch Name', value: 'bankBranch' },
];
